/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * WordPress dependencies
 */
import { BaseControl, Button, HStack } from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import { space } from '../../components/utils/space';

export const Container = styled.fieldset`
	border: 0;
	margin: 0;
	padding: 0;
	display: contents;
`;

export const Header = styled( HStack )`
	height: ${ space( 4 ) };
`;

export const HeaderToggle = styled( Button )`
	margin-top: ${ space( -1 ) };
`;

export const HeaderLabel = styled( BaseControl.VisualLabel )`
	display: flex;
	gap: ${ space( 1 ) };
	justify-content: flex-start;
	margin-bottom: 0;
`;
